<template>

<div class="footer">
    <div class="fc">
    <div class="lj">
        <div class="item">
            <span class="x">服务热线</span>
            <span class="d">021-60665499</span>
        </div>

        <div class="tu_set">
            <div class="it">
                <img src="https://oss.mifengbangzu.com/web/gfgzh.jpg">
                <div>官方公众号</div>
            </div>
           <div class="it">
                <img src="https://oss.mifengbangzu.com/web/fyxt2.jpg">
                <div>圆租系统</div>
            </div>
            <div class="it">
                <img src="https://oss.mifengbangzu.com/web/ajxt2.jpg">
                <div>销售系统</div>
            </div>
  
            
        </div>
    </div>


    </div>
    <div class="icp">
版权为运长集团所有     2022     沪ICP备11009004号-1
    </div>
</div>

</template>
<script>
  export default {
  	name: "WebFooter",
    data() {
        return {
        };
    },
  }
</script>
<style lang="scss" scoped>

.footer{
    background-color:#11934e;
    height: 404px;
    .icp{
        height: 80px;
        border-top: solid #fff 1px;
        text-align: center;
        line-height: 80px;
        font-size: 16px;
    }
    width: 100%;
    color:#fff;
    .fc{
        width: 1000px;
        height: 320px;
        margin-left: auto;
        margin-right: auto;

        .contact{
            padding-top: 20px;
            color: #fff;
            font-size: 18px;  
            padding-bottom:20px ;
            .d{
                margin-left: 5px;
                font-size: 25px;    
            }
            .xx{margin-left: 80px;}
        }
    }
    .lj{
        display: flex;
        margin-top: 20px;
        padding-top: 80px;
        font-size: 16px;
        .item{
            font-size: 20px;
            //margin-right: 80px;
            div{
                margin-top: 10px;
                &:first-child{
                      margin-top: unset;
                }
            }
            
            .d{
             font-size: 35px;
             
            }
        }
        .tu_set{
            margin-left: 230px;
            display: flex;
            .it{
                margin-right: 10px;
                    img{
                        width: 130px;
                        height: 130px;
                    }
                    div{
                        margin-top: 10px;
                        text-align:center;
                    }

            }
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/layouts/WebFooter/index.vue